import { IAnswerList, ILeadStep, IQuestionStep, TCallbackFunction, TQuizEventType, TQuizStep } from 'feed';
import { v4 as tempUuidV4 } from 'uuid';
import { LINK_FOR_PERSONAL_POLICY } from '~/actions/constants';
import { QuizEventProperties } from '~/actions/quiz/types';
import RestServices from '~/api';
import { origin } from '~/api/Services';

class ProcessingQuizEvent {
  public quizKey: string;

  constructor() {
    this.quizKey = tempUuidV4();
  }

  /**
 * Дополняет данные для отправки при событии ANSWER_QUESTION
 * @param quizCurrentStep 
 * @returns 
 */
  protected prepareDataForAnswerQuestionType = (quizCurrentStep: IQuestionStep) => {
    switch (quizCurrentStep.answerType) {
      case 'LIST':
        return (quizCurrentStep.answers as IAnswerList[]).filter(
          answer => answer.checked
        ).map(answer => ({ answerUUID: answer.uuid })); // Только выбранные пользователем ответы их uuid
      case 'INPUT':
        return quizCurrentStep.answers.map(
          answer => ({ answerUUID: answer.uuid, text: answer.text })
        );
    }
  }

  /**
   * Дополняет данные для отправки при событии SEND_LEAD
   * @param quizCurrentStep 
   * @returns 
   */
  protected prepareDataForSendLeadType = (quizCurrentStep: ILeadStep) => {
    return {
      phone: quizCurrentStep.phone,
      email: quizCurrentStep.email,
      name: quizCurrentStep.name,
    };
  }

  /**
   * Подготавливает данные для отправки событий квиза
   * @param eventType 
   * @param quizCurrentStep 
   * @returns 
   */
  protected createResponseData = (eventType: TQuizEventType, quizCurrentStep: TQuizStep) => {
    const responseData: QuizEventProperties = {
      '@type': 'QuizEvent',
      'eventTypeCode': eventType,
      'eventTimestamp': Date.now(),
      'quizKey': this.quizKey,
      'stepUUID': quizCurrentStep.uuid,
    };
    if (quizCurrentStep && (eventType === 'ANSWER_QUESTION' || eventType === 'SEND_LEAD')) {
      switch (eventType) {
        case 'ANSWER_QUESTION': {
          responseData.answers = this.prepareDataForAnswerQuestionType(quizCurrentStep as IQuestionStep);
          break;
        }
        case 'SEND_LEAD': {
          responseData.contactData = this.prepareDataForSendLeadType(quizCurrentStep as ILeadStep);
          break;
        }
      }
    }

    return responseData;
  }

  /**
   * Отправляет события квиза
   * @param quizId 
   * @param eventType 
   * @param quizCurrentStep 
   */
  public processingEvent: TCallbackFunction = (
    eventType: TQuizEventType,
    quizCurrentStep: TQuizStep
  ) => {
    // Клик по ссылке в тексте согласия на обработку персональных данных на шаге отправки данных пользователя
    if (eventType === 'CLICK_ON_CONSENT_LINK') {
      window.open(`${origin}/${LINK_FOR_PERSONAL_POLICY}`, '_blank');

      return;
    }
    // Отправка событий квиза
    RestServices.quizEvent.set({
      ...this.createResponseData(eventType, quizCurrentStep),
    });
  }
}

export default ProcessingQuizEvent;